import React from "react";
import PropTypes from "prop-types";

import BottomBar from "../../../ui/BottomBar";
import StepContainer from "../../../ui/StepContainer";
import StepForm from "../../../ui/StepForm";
import { STEP_STORAGE_KEYS } from "../../../constants/storageConstants";
import { projectDataPropType } from "../../../util/propTypeHelper";
import ValueOfTimeAndCrashesForm from "./ValueOfTimeAndCrashesForm";
import Header from "../../../ui/Header";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../constants/routesConstants";

export default function CostParametersDefaults({ projectData, saveFormData }) {
  const navigate = useNavigate();
  const handleButtonClick = () => navigate(ROUTES.COST_PARAMETERS);
  return (
    <StepContainer withProgressStepper={false}>
      <StepForm
        onFormSubmit={handleButtonClick}
        projectData={projectData}
        saveFormData={saveFormData}
        storageKey={STEP_STORAGE_KEYS.COST_PARAMETERS_DEFAULTS}
      >
        {({ defaultValues, errors, formData, register, isDirty }) => {
          return (
            <>
              <Header
                subtitle="Contains default discount rate, value of time, and cost of crashes. Default values can be overridden"
                title="Cost Parameters Defaults"
              />
              <ValueOfTimeAndCrashesForm
                defaultValues={defaultValues}
                errors={errors}
                formData={formData}
                register={register}
              />
              <BottomBar
                handleSecondaryButtonClick={handleButtonClick}
                isFormDirty={isDirty}
                isFullScreenWidth
                mainButtons={[{ label: "Save" }]}
                projectData={projectData}
                secondaryButtonLabel="Cancel"
                withSubmitButton
              />
            </>
          );
        }}
      </StepForm>
    </StepContainer>
  );
}

CostParametersDefaults.propTypes = {
  projectData: projectDataPropType.isRequired,
  saveFormData: PropTypes.func.isRequired,
};
